import { CSSProperties, ReactNode } from 'react';

type LinkWrapperProps = {
  children: ReactNode;
  style?: CSSProperties;
  hyperlink?: string;
};

export const LinkWrapper = ({ children, hyperlink, style }: LinkWrapperProps) => {
  if (hyperlink) {
    return (
      <a href={hyperlink} rel='noreferrer nofollow' target='_blank' style={style}>
        {children}
      </a>
    );
  }

  return <>{children}</>;
};
